// client/src/pages/user/Wallet.js
import { useState } from "react";
import api from "../../api/axiosInstance";
import { toast } from "react-hot-toast";

export default function Wallet() {
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("UPI");
  const [reference, setReference] = useState("");

  const submit = async () => {
    try {
      await api.post("/wallet/request", {
        amount,
        method,
        reference,
      });
      toast.success("💰 Wallet Request Submitted for approval");
      setAmount("");
      setReference("");
    } catch (e) {
      toast.error(e.response?.data?.message || "Wallet Request Failed");
    }
  };

  return (
    <div className="max-w-md space-y-4">
      <h1 className="text-2xl font-bold">Add Wallet Balance</h1>

      <input
        type="number"
        className="input-glass w-full"
        placeholder="Enter amount"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
      />

      <select
        className="input-glass w-full bg-[#0b0f17] text-white"
        value={method}
        onChange={(e) => setMethod(e.target.value)}
      >
        <option value="UPI" className="bg-[#0b0f17] text-white">
          UPI
        </option>
        <option value="BANK" className="bg-[#0b0f17] text-white">
          Bank Transfer
        </option>
        <option value="CRYPTO" className="bg-[#0b0f17] text-white">
          Crypto
        </option>
      </select>

      {/* PAYMENT DETAILS */}
      {method === "UPI" && (
        <div className="text-sm text-gray-300 space-y-1">
          <p>
            <b>UPI ID:</b> ketan007sir@okaxis
          </p>
          <p>Scan & pay, then enter reference below</p>
        </div>
      )}

      {method === "BANK" && (
        <div className="text-sm text-gray-300 space-y-1">
          <p>
            <b>A/C Holder Name:</b> MR. KETAN NERURKAR
          </p>
          <p>
            <b>Bank:</b> THE SARASWAT CO-OPERATIVE BANK LTD.
          </p>
          <p>
            <b>A/C:</b> 451203100002559
          </p>
          <p>
            <b>IFSC:</b> SRCB0000451
          </p>
        </div>
      )}

      {method === "CRYPTO" && (
        <div className="text-sm text-gray-300 space-y-1">
          <p>
            <b>USDT (TRC20):</b>
          </p>
          <p>NO CRPTO ARE ACCEPTED RIGHT NOW...</p>
        </div>
      )}

      <input
        className="input-glass w-full"
        placeholder="Transaction reference / UTR / TXN ID"
        value={reference}
        onChange={(e) => setReference(e.target.value)}
      />

      <button onClick={submit} className="btn-primary w-full">
        Submit Request
      </button>
    </div>
  );
}
